__turbopack_context__.v({
  "all_blog_content": "Blogs-module-scss-module__iKv_Ua__all_blog_content",
  "all_blog_image": "Blogs-module-scss-module__iKv_Ua__all_blog_image",
  "all_blogs": "Blogs-module-scss-module__iKv_Ua__all_blogs",
  "blog_bottom": "Blogs-module-scss-module__iKv_Ua__blog_bottom",
  "blog_child_image": "Blogs-module-scss-module__iKv_Ua__blog_child_image",
  "blog_date": "Blogs-module-scss-module__iKv_Ua__blog_date",
  "blog_footer": "Blogs-module-scss-module__iKv_Ua__blog_footer",
  "blog_footer_content": "Blogs-module-scss-module__iKv_Ua__blog_footer_content",
  "blog_page_btn": "Blogs-module-scss-module__iKv_Ua__blog_page_btn",
  "blog_page_social_links": "Blogs-module-scss-module__iKv_Ua__blog_page_social_links",
  "blog_social_links_parent": "Blogs-module-scss-module__iKv_Ua__blog_social_links_parent",
  "blog_text1": "Blogs-module-scss-module__iKv_Ua__blog_text1",
  "blog_title": "Blogs-module-scss-module__iKv_Ua__blog_title",
  "blog_top": "Blogs-module-scss-module__iKv_Ua__blog_top",
  "blog_top_img": "Blogs-module-scss-module__iKv_Ua__blog_top_img",
  "blogs": "Blogs-module-scss-module__iKv_Ua__blogs",
  "blogs_child": "Blogs-module-scss-module__iKv_Ua__blogs_child",
  "blogs_sec": "Blogs-module-scss-module__iKv_Ua__blogs_sec",
  "button_sec": "Blogs-module-scss-module__iKv_Ua__button_sec",
  "h5_text": "Blogs-module-scss-module__iKv_Ua__h5_text",
  "highlight_div": "Blogs-module-scss-module__iKv_Ua__highlight_div",
  "images_sec": "Blogs-module-scss-module__iKv_Ua__images_sec",
  "link_icon": "Blogs-module-scss-module__iKv_Ua__link_icon",
  "read_more_btn": "Blogs-module-scss-module__iKv_Ua__read_more_btn",
  "recent_blog_bottom_img": "Blogs-module-scss-module__iKv_Ua__recent_blog_bottom_img",
  "recent_blog_bottom_img_content": "Blogs-module-scss-module__iKv_Ua__recent_blog_bottom_img_content",
  "recent_blog_bottom_img_sec": "Blogs-module-scss-module__iKv_Ua__recent_blog_bottom_img_sec",
  "recent_blog_sec": "Blogs-module-scss-module__iKv_Ua__recent_blog_sec",
  "recent_bottom": "Blogs-module-scss-module__iKv_Ua__recent_bottom",
  "recent_bottom_main": "Blogs-module-scss-module__iKv_Ua__recent_bottom_main",
  "recent_bottom_right": "Blogs-module-scss-module__iKv_Ua__recent_bottom_right",
  "recent_top": "Blogs-module-scss-module__iKv_Ua__recent_top",
  "single_blog": "Blogs-module-scss-module__iKv_Ua__single_blog",
  "single_blog_destinations_btn": "Blogs-module-scss-module__iKv_Ua__single_blog_destinations_btn",
  "single_blog_page_top": "Blogs-module-scss-module__iKv_Ua__single_blog_page_top",
  "single_blog_parent": "Blogs-module-scss-module__iKv_Ua__single_blog_parent",
  "single_blog_top_banner": "Blogs-module-scss-module__iKv_Ua__single_blog_top_banner",
  "sticky_recent_posts": "Blogs-module-scss-module__iKv_Ua__sticky_recent_posts",
  "top_blog": "Blogs-module-scss-module__iKv_Ua__top_blog",
  "top_blog_content": "Blogs-module-scss-module__iKv_Ua__top_blog_content",
  "top_blog_image": "Blogs-module-scss-module__iKv_Ua__top_blog_image",
});
